<template>
  <div class="history" :class="guest ? 'container':''">
    <h2 class="profile__header">
      {{ $t('consultations.header') }}
    </h2>

    <div class="row">
      <div class="col-12 offset-0 col-lg-6 offset-lg-3">
        <div class="history__form">
          <h4> {{ $t('consultations.doctor_specialization') }}</h4>
          <v-select v-model="selectedSpecialization"
                    :options="specializationsList"
                    :searchable="false"
                    class="userSelect" label="title">
          </v-select>

          <template v-if="selectedSpecialization && selectedSpecialization.id">
            <h4>{{ $t('consultations.choose_clinic') }}</h4>
            <div class="history__clinic"
                 v-for="clinic in clinics"
                 :class="{ 'history__clinic-active': selectedClinic && clinic.id === selectedClinic.id }"
                 @click="handleChangeClinic(clinic)">
              <h3>{{ clinic.title }}</h3>
              <span>{{ clinic.address }}</span>
            </div>
          </template>

          <button class="btn" :disabled="!selectedSpecialization || !selectedSpecialization.id" @click="searchDoctor">
            {{ $t('consultations.choose_doctor') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import config from '@/helpers/configDateFormats';
import {mapGetters} from "vuex";
import boot from "@/boot/default";

export default {
  name: 'order-find-doctor',
  props: {
    specialization_id: {
      required: false,
      type: [Number, String],
    },
    clinic_id: {
      required: false,
      type: [Number, String],
    },
    guest: {
      default: false,
      type: [Boolean],
    },
    language: {
      default: 'ru',
      type: [String],
    },
  },
  data() {
    return {
      selectedSpecialization: null,
      selectedClinic: null,
    }
  },
  computed: {
    ...mapGetters([
      'clinics',
      'specializations'
    ]),
    specializationsList() {
      let placeholder = {
        id: null,
        title: "Виберіть спеціалізацію",
        service_name: "Виберіть спеціалізацію"
      };
      let specializationsList = []
      specializationsList.push(placeholder)
      specializationsList = specializationsList.concat(this.specializations.filter((item) => item.can_be_ordered))

      return specializationsList
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    handleChangeClinic(clinic) {
      if (clinic === this.selectedClinic) {
        this.selectedClinic = null;
      } else {
        this.selectedClinic = clinic;
      }
    },
    searchDoctor() {
      let query = {};

      if (this.selectedSpecialization) {
        query = {
          ...query,
          specialization_id: this.selectedSpecialization.id,
        };
      }

      if (this.selectedClinic) {
        query = {
          ...query,
          clinic_id: this.selectedClinic.id,
        };
      }

      if (this.guest) {
        this.$router.push({
          name: 'order.choose-doctor',
          query,
        })
      } else {
        this.$router.push({
          name: 'profile.order.choose-doctor',
          query,
        })
      }
    },
  },
  mounted() {
    if(this.guest){
      this.$store.dispatch('setLanguage', {language:this.language})
    }

    this.$store
        .dispatch('getSpecialization')
        .then(response => {
          this.selectedSpecialization = {
            id: null,
            title: this.$t('consultations.choose'),
            service_name: this.$t('consultations.choose')
          };

          for (let specialization of this.specializations) {
            if (specialization.id === Number.parseInt(this.specialization_id)) {
              this.selectedSpecialization = specialization;
              break;
            }
          }
        });

    for (let clinic of this.clinics) {
      if (clinic.id === Number.parseInt(this.clinic_id)) {
        this.selectedClinic = clinic;
        break;
      }
    }
  },
  components: {},
}
</script>
